import { requiredLoginLevel } from 'utils/routes/requiredLoginLevel';
import { verifyRequiredBetaFeatures } from 'utils/betaFeatures/verifyRequiredBetaFeatures';
import { verifyRequiredFeatures } from 'utils/features/verifyRequiredFeatures';
import { excludeLoginLevel } from 'utils/routes/excludeLoginLevel';
import { BetaFeatures, Features } from 'apps/settings/consts';
import { AuthenticationLevel } from 'auth';
import { allowSuperuserOnly } from 'utils/routes/allowSuperuserOnly';
import { redirectToChangeCredentials } from 'apps/sso/redirectHandlers';
import { loadFoodProfileConditions } from 'apps/foodProfile/utils';

export default [
  {
    path: 'settings',
    indexRoute: {
      onEnterHandlers: [
        requiredLoginLevel(AuthenticationLevel.ELEVATED),
        verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      ],
      getComponent(location, callback) {
        import(/* webpackChunkName: "settings" */ './containers/Settings')
          .then(component => callback(null, component.default));
      },
    },
    childRoutes: [
      // require ELEVATED & ACCOUNT_SETTINGS_RAVEN
      {
        onEnterHandlers: [
          requiredLoginLevel(AuthenticationLevel.ELEVATED),
          verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
        ],
        childRoutes: [
          {
            path: 'delivery-preferences',
            getComponent(location, callback) {
              import(/* webpackChunkName: "settings" */ './containers/DeliveryPreferences')
                .then(component => callback(null, component.default));
            },
          },
          {
            path: 'marketing-communications',
            getComponent(location, callback) {
              import(/* webpackChunkName: "settings" */ '[theme-lib]/apps/settings/containers/MarketingCommunications')
                .then(component => callback(null, component.default));
            },
          },
          {
            path: 'cookies',
            getComponent(location, callback) {
              import(/* webpackChunkName: "settings" */ './components/Cookies')
                .then(component => callback(null, component.default));
            },
          },
          {
            path: 'calendar-reminders',
            getComponent(location, callback) {
              import(/* webpackChunkName: "settings" */ './containers/CalendarEvents')
                .then(component => callback(null, component.default));
            },
          },
          {
            path: 'delivery-sms-reminders',
            getComponent(location, callback) {
              import(/* webpackChunkName: "settings" */ './containers/SmsAlerts')
                .then(component => callback(null, component.default));
            },
          },
          {
            path: 'facebook-login',
            onEnterHandlers: [
              redirectToChangeCredentials(),
            ],
            getComponent(location, callback) {
              import(/* webpackChunkName: "settings" */ './containers/FacebookSettings')
                .then(component => callback(null, component.default));
            },
          },
          {
            path: 'contact-details',
            getComponent(location, callback) {
              import(/* webpackChunkName: "settings" */ './containers/ContactDetails')
                .then(component => callback(null, component.default));
            },
          },
          {
            path: 'paypal-login',
            onEnterHandlers: [
              verifyRequiredFeatures([Features.PAYPAL_LOGIN]),
              redirectToChangeCredentials(),
            ],
            getComponent(location, callback) {
              import(/* webpackChunkName: "settings" */ './containers/PaypalSettings')
                .then(component => callback(null, component.default));
            },
          },
          {
            path: 'login-password',
            onEnterHandlers: [
              excludeLoginLevel(AuthenticationLevel.SUPERUSER),
              redirectToChangeCredentials(),
            ],
            getComponent(location, callback) {
              import(/* webpackChunkName: "settings" */ './containers/ChangeCredentials')
                .then(component => callback(null, component.default));
            },
          },
          {
            path: 'address-book',
            getComponent(location, callback) {
              import(/* webpackChunkName: "settings" */ './containers/DeliveryAddressBook')
                .then(component => callback(null, component.default));
            },
          },
          {
            path: 'address-book/add',
            getComponent(location, callback) {
              import(/* webpackChunkName: "settings" */ './containers/AddDeliveryAddress')
                .then(component => callback(null, component.default));
            },
          },
          {
            path: 'address-book/:id/edit',
            getComponent(location, callback) {
              import(/* webpackChunkName: "settings" */ './containers/EditDeliveryAddress')
                .then(component => callback(null, component.default));
            },
          },
          {
            path: 'address-book/:id/override',
            onEnterHandlers: [
              allowSuperuserOnly,
            ],
            getComponent(location, callback) {
              import(/* webpackChunkName: "settings" */ './containers/OverrideDeliveryAddress')
                .then(component => callback(null, component.default));
            },
          },
          {
            path: 'checkout',
            onEnterHandlers: [
              allowSuperuserOnly, // it still will work correctly with global ELEVATED check because SUPERUSER > ELEVATED
            ],
            getComponent(location, callback) {
              import(/* webpackChunkName: "settings" */ './containers/SuperuserCheckout')
                .then(component => callback(null, component.default));
            },
          },
          {
            path: 'payment-details',
            getComponent(location, callback) {
              import(/* webpackChunkName: "settings" */ './containers/StoredPaymentDetails')
                .then(component => callback(null, component.default));
            },
          },
          {
            path: 'add-payment-type',
            getComponent(nextState, callback) {
              import(/* webpackChunkName: "settings" */ './containers/AddNewPaymentMethod')
                .then(component => callback(null, component.default));
            },
          },
        ],
      },
      // other
      {
        childRoutes: [
          {
            path: 'calorie-saver',
            onEnterHandlers: [
              requiredLoginLevel(AuthenticationLevel.ELEVATED),
              verifyRequiredBetaFeatures([
                BetaFeatures.ACCOUNT_SETTINGS_RAVEN,
                BetaFeatures.HEALTHIFY,
              ]),
            ],
            getComponent(location, callback) {
              import(/* webpackChunkName: "settings" */ './containers/CalorieSaver')
                .then(component => callback(null, component.default));
            },
          },
          {
            path: 'food-profile',
            onEnterHandlers: [
              requiredLoginLevel(AuthenticationLevel.LOGGED_IN),
              loadFoodProfileConditions,
            ],
            getComponent(location, callback) {
              import(/* webpackChunkName: "settings" */ './containers/FoodProfile')
                .then(component => callback(null, component.default));
            },
          },
        ],
      },
    ],
  },
];
